export default "__VITE_ASSET__By5A0PB4__"